import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const fileApi = createApi({
    reducerPath: "files",
      baseQuery: createCustomFetchBaseQuery(),
    // baseQuery: fetchBaseQuery({
    //     baseUrl: 'http://192.168.100.23:4001/api',
    // }),
    endpoints: (builder) => ({
        uploadNewFile: builder.mutation({
            query: (fileData) => {
                const formData = new FormData();
                formData.append("files", fileData);
                return {
                    // url: "file/upload", 
                    url: "/upload/s3", 
                    method: "POST",
                    body: formData,
                };

            },
            transformResponse: (res) => res?.data,
        }),
        deleteFile: builder.mutation({
            query: (filename) => ({
                url: `/upload/s3`,
                method: "DELETE",
                body: { fileKey: filename },
            }),
        }),
    }),
});

export const { useUploadNewFileMutation, useDeleteFileMutation } = fileApi;
